/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {
    export class AutoCompleteService implements IService {

        constructor(private $http: angular.IHttpService) { }

        public runAutoComplete(processConfigurationId: string, autoCompleteId: string, searchValue: string): angular.IHttpPromise<any> {
            const url = `./api/AutoComplete/processConfig/${processConfigurationId}/${autoCompleteId}`;
            return this.$http.post(url, '"' + searchValue + '"');
        }
    }
}

warsApp.registerService('AutoCompleteService', ['$http']);
